import React from 'react';
import { Box, Stepper, Step, StepLabel, Typography, Button } from '@mui/material';

export interface ISteps {
  title: string; step: string, optional: boolean, tooltip?: string
}

interface IStepperContainerProps {
  steps: ISteps[];
  activeStep: number;
  setActiveStep: React.Dispatch<React.SetStateAction<number>>,
  onSubmitForm: () => void,
  isSetupSuccessful: boolean,
  children?: React.ReactNode
}

const StepperContainer: React.FC<IStepperContainerProps> = ({
  steps,
  activeStep,
  setActiveStep,
  onSubmitForm,
  isSetupSuccessful,
  children
}) => {

  const isStepOptional = (step: number) => {
    return steps[step].optional;
  };

  const handleNext = () => {
    if (activeStep === steps.length - 1) {
      onSubmitForm();
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Box display="flex" flexDirection="column" minHeight="80vh" maxWidth={1150} m={{sm: 2, md: 4}} className="no-select">
      <Stepper activeStep={activeStep}>
        {steps.map((step, index) => {
          const stepProps: { completed?: boolean } = {};
          const labelProps: { optional?: React.ReactNode } = {};

          if (isStepOptional(index)) {
            labelProps.optional = <Typography variant="body2">Optional</Typography>;
          }
          return (
            <Step key={step.title} {...stepProps}>
              <StepLabel {...labelProps}>{step.step}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
        {children}
      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "end", pt: 2 }}>
        <Button disabled={activeStep === 0} onClick={handleBack} sx={{ mr: 2 }}>
          Zurück
        </Button>
        <Button disabled={!isSetupSuccessful && (activeStep === steps.length - 1)} variant='contained' onClick={handleNext}>
          {activeStep === steps.length - 1 ? 'E-Display Öffnen' : 'Weiter'}
        </Button>
      </Box>
    </Box>
  );
};

export default StepperContainer;
